<template>
  <div class="log">

    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">新增收货地址</p>
      </div>
    </header>
    <div class="personalMain">
      <!--<div class="inforName">-->
      <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
      <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
      <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">收货人</p>
        <div class="inforRight">
          <p> <input class="inforNameInput" type="" v-model="data.name" placeholder="请填写收货人姓名" ></p>
          <p><van-icon name="manager-o" /></p>
        </div>

      </div>
      <div class="inforName">
        <p class="inforNameTop">手机号码</p>
        <div class="inforRight">
        <p> <input class="inforNameInput" type="text" v-model="data.tel" placeholder="请填写收货人手机号" ></p>
        <p><van-icon name="phone-o" /></p>
        </div>
      </div>

      <div class="inforName">
        <p class="inforNameTop">所在地区</p>
        <div class="inforRight">
        <p style="width: 100%">
          <van-field
            v-model="fieldValue"
            is-link
            readonly
            label=""
            placeholder="请选择所在地区"
            @click="show = true"
          />
          <van-popup v-model="show" round position="bottom">
            <van-cascader
              v-model="cascaderValue"
              title="请选择所在地区"
              :options="option"
              @close="show = false"
              @change="onChange"
              @finish="onFinish"
            />
          </van-popup>
        </p>
        </div>
      </div>
      <div class="inforName">
        <p class="inforNameTop">详细地址</p>
        <div class="inforRight">
        <p> <input class="inforNameInput" type="text" v-model="data.address" placeholder="请填写详细地址" ></p>
        </div>
      </div>
      <div>
        <p class="defaultDiv"><span>设置默认地址</span><span><van-switch v-model="checked" active-color="#ee0a24" inactive-color="#dcdee0" size="15px" /></span></p>
        <p class="remind">提醒：每次下单会默认推荐使用该地址</p>
      </div>

    </div>
    <div class="buttonSave">
      <van-button style="width: 100%;margin: 0 auto" color="#ee0a24" type="primary" @click="insertAddress()">保存</van-button>

    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        show: false,
        fieldValue: '',
        cascaderValue: '',
        // 选项列表，children 代表子选项，支持多级嵌套
        option: [],
        list: [],
        data: {
          name: "",
          tel:"",
          province :"",
          city :"",
          county:"",
          address:"",
          postal_code :"",
          is_default:"",

        },
        index:0,
        arr:[],
        checked:true,
        options: [
          {
            text: '浙江省',
            value: '330000',
            children: [{ text: '杭州市', value: '330100',children:[] }],
          },
          {
            text: '江苏省',
            value: '320000',
            children: [{ text: '南京市', value: '320100' }],
          },
        ],
      };

    },
    methods:{
      findDep(node = [],arr=[]) {
        for(let item of node) {
          arr.push({a: item.a,b: item.b})
          //将c对象存进数组，便于递归遍历
          let parentArr = []
          if(item.c) parentArr.push(item.c)
          if(parentArr && parentArr.length) this.findDep(parentArr,arr)
        }
        return arr
      },
      backHistory(){
        this.$router.go(-1)
      },
      onChange({ value,selectedOptions }) {
        if (selectedOptions.length==3) return
        const targetOption = selectedOptions[selectedOptions.length - 1];
        var adressList=[];
        this.$api.selectRegion({
          pid:value
        }).then(res=>{
          res.data.length==0?this.index=1:this.index=0
          if(res.data.length!=0){
            res.data.forEach(item=>{
              adressList.push({
                text:item.name,
                value:item.id,
              })
            });
            targetOption.children=adressList;
            this.option=[...this.option]
          }

        });

     }
      ,
      onFinish({ selectedOptions }) {
        console.log(selectedOptions)
        let _this=this
        if (selectedOptions.length==3){
          this.show = false;
          this.fieldValue = selectedOptions.map((option) => option.text);
          selectedOptions.forEach(function (res) {
            console.log(res)
            _this.arr.push(res.value)
          })
          console.log(_this.arr)
        }

      },
      selectRegioner(){
        this.$api.selectRegion({
          pid:""
        }).then(res=>{
//          this.list=res.data
          let _this=this
          res.data.forEach(function (item,index) {
            _this.option.push({text:item.name,value:item.id,pid:item.pid,children:[]})
          })
        })
          .catch(err=>{
          })
      },
      insertAddress(){
        console.log(this.$route.query)
        let bool=this.checked? 1 : 0
        this.$api.insertAddress({
          "data[user_id]":localStorage.getItem("userid"),
          "data[name]":this.data.name,
          "data[tel]":this.data.tel,
          "data[province]":this.arr[0],
          "data[city]":this.arr[1],
          "data[county]":this.arr[2],
          "data[address]":this.data.address,
          "data[postal_code]":"100000",
          "data[is_default]":bool

        }).then(res=>{
          this.$toast("保存成功")
          if(localStorage.getItem("sendId")){
            this.$router.push({
              path:"/orderPage",
              query:this.$route.query,
//              query:{
//                id:localStorage.getItem("sendId")
//              }
            })
          }else {
            this.$router.push("/harvestAddress")
          }
        })

      },
    },
    mounted(){
      this.selectRegioner()
    }
  }
</script>
<style scoped="">
  header{
    width: 100%;
    height: 60px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 60px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 18px;
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 8rem 18px 0 18px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    /*font-size: 13px;*/
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
  .buttonSave{
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
  }
  .defaultDiv{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .remind{
   color: grey;
    font-size: 13px;
  }
  .inforRight{
    display: flex;
    justify-content: space-between;
    /* flex: 1; */
    width: 70%;
  }
  /deep/ .van-cell{
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/newAddress.vue